<div
    class="agpr-handlesChips"
>
    <div class="agpr-handlesChips-column">
        <agpr-text-input
            #textInput
            [label]="label"
            [id]="id + '_textInput'"
            [placeholder]="placeholder"
            [disabled]="disabled"
            [maxLength]="maxLength"
            [bottomMargin]="false"
            [(ngModel)]="newChipText"
            [ngClass]="{
                'agpr-squareborder': value?.length > 0
            }"
            (keyup)="handleTextInputKeyUp($event)"
            (blur)="tryAddChip()"
            [required]="required"
            [ariaInvalid]="showError"
            [ariaDescribedBy]="id + '_handlesChips_errorMessage' + ' ' + (id + '_chips') + ' ' + ariaDescribedBy"
            [hint]="hint"
        ></agpr-text-input>

        @if (value?.length > 0) {
            <ul
                #chipList
                [id]="id + '_chips'"
                class="agpr-handlesChips-list"
                [attr.aria-labelledby]="id + '_textInput_label'"
            >
                @for (chip of value; track chip; let i = $index) {
                    <li
                        #token
                        [id]="id + '_chip_' + i"
                        class="agpr-handlesChips-listItem"
                    >
                        <div
                            class="agpr-handlesChips-chipContainer"
                            [ngClass]="{'agpr-handlesChips-editable': true}"
                        >
                            @if (chip.link) {
                                <a
                                    [href]="chip.link"
                                    [pTooltip]="tooltip && chip.link.length > 55 ? chip.link : null"
                                    tooltipPosition="top"
                                    target="_blank"
                                    rel="noopener"
                                    class="agpr-handlesChips-label"
                                    [ngClass]="{ 'agpr-handlesChips-label--primary': chip.primary }"
                                >
                                    <span>{{ chip.value }}</span>
                                </a>
                            } @else {
                                <span
                                    class="agpr-handlesChips-label"
                                    [pTooltip]="tooltip && chip.value?.length > 55 ? chip.value : null"
                                    tooltipPosition="top"
                                >
                                    {{ chip.value }}
                                </span>
                            }

                            @if (chip.primary) {
                                <span
                                    role="img"
                                    class="agpr-handlesChips-badge fa-solid fa-award"
                                    agprTooltip="Discover.entityProfile.handle.primary"
                                ></span>
                            }

                            @if (chip.preferred) {
                                <span
                                    role="img"
                                    class="agpr-handlesChips-badge fa-solid fa-star"
                                    agprTooltip="Discover.entityProfile.handle.preferred"
                                ></span>
                            }

                            @if (chip.isPrivateData) {
                                <span
                                    role="img"
                                    class="agpr-handlesChips-badge fa-regular fa-duotone fa-shield-keyhole"
                                    agprTooltip="Discover.addPrivateDataDialog.privateData"
                                ></span>
                            }

                            <div class="agpr-handlesChips-chipContainer-contextMenu">
                                @if (!chip.primary && !addPrivateData) {
                                    <agpr-button
                                        [id]="id + '_makePrimary_' + i"
                                        class="agpr-handlesChips-contextMenu-setPrimary"
                                        [style]="buttonTypes.icon"
                                        [tooltip]="'Discover.entityProfile.handle.primary.set'"
                                        icon="fa-regular fa-star"
                                        (click)="setPrimary(chip)"
                                    ></agpr-button>
                                }

                                <!-- You are only able to set the primary as "preferred" as a way of clearing a
                                previous preference. -->
                                @if (addPrivateData && !chip.preferred &&
                                    chip.handleType === handleTypeEnum.EMAIL &&
                                    ((chip.primary && hasPreferredEmail) || !chip.primary)
                                ) {
                                    <agpr-button
                                        [id]="id + '_preferredHandle_' + i"
                                        class="agpr-handlesChips-contextMenu-setPrimary"
                                        [style]="buttonTypes.icon"
                                        [tooltip]="'Discover.entityProfile.handle.preferred.set'"
                                        icon="fa-regular fa-star"
                                        (click)="setPreferred(chip)"
                                    ></agpr-button>
                                }

                                @if (chip.editable) {
                                    <agpr-button
                                        [id]="id + '_deleteHandle_' + i"
                                        class="agpr-handlesChips-contextMenu-trash"
                                        [style]="buttonTypes.icon"
                                        [icon]="'fa-regular fa-duotone fa-trash-can'"
                                        (click)="removeChip(i)"
                                        tooltip="Discover.addPrivateDataDialog.deleteItem"
                                    ></agpr-button>
                                }
                            </div>
                        </div>
                    </li>
                }
            </ul>
        }

        @if (showError) {
            <agpr-form-message [id]="id + '_handlesChips_errorMessage'">
                {{ errorMessage | localize }}
            </agpr-form-message>
        }
    </div>

    @if (addPrivateData) {
        <agpr-button
            [disabled]="!newChipText"
            [style]="buttonTypes.icon"
            icon="fa-regular fa-duotone fa-square-plus"
            [tooltip]="!!addButtonTooltip ? addButtonTooltip : 'Discover.addPrivateDataDialog.addHandle'"
            tooltipPosition="top"
            (click)="tryAddChip()"
        ></agpr-button>
    }
</div>

